import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PayableTable } from "../../types/Payable.types";

interface PayableTableState {
  list: PayableTable[];
  paginator: any;

  pendingSupplierPayables: PayableTable[];

  page: number;
  size: number;
  sort: string;

  loading: boolean;
  error: string | null;
}

const initialState: PayableTableState = {
  list: [],
  paginator: null,

  pendingSupplierPayables: [],

  page: 0,
  size: 5,
  sort: "dueDate,desc",

  loading: false,
  error: null,
};

const payableTableSlice = createSlice({
  name: "payableTable",
  initialState,
  reducers: {
    // 🔄 loading
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // ❌ error
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    // 📊 set data
    setPayables(
      state,
      action: PayloadAction<{ content: PayableTable[] }>
    ) {
      state.list = action.payload.content;
      state.paginator = action.payload;
      state.loading = false;
    },

    // 🧹 limpiar tabla
    clearPayables(state) {
      state.list = [];
      state.paginator = null;
    },

    // 📄 paginación
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },

    setSize(state, action: PayloadAction<number>) {
      state.size = action.payload;
    },

    setSort(state, action: PayloadAction<string>) {
      state.sort = action.payload;
    },

    // 💰 cuentas pendientes del proveedor
    setPendingSupplierPayables(
      state,
      action: PayloadAction<PayableTable[]>
    ) {
      state.pendingSupplierPayables = action.payload;
    },

    clearPendingSupplierPayables(state) {
      state.pendingSupplierPayables = [];
    },
  },
});

export const {
  setLoading,
  setError,
  setPayables,
  clearPayables,
  setPage,
  setSize,
  setSort,
  setPendingSupplierPayables,
  clearPendingSupplierPayables,
} = payableTableSlice.actions;

export default payableTableSlice.reducer;